import type { AccessCardKind } from '../api/parkingManagementApi';

const FEE_CODE_TO_KIND: Record<string, AccessCardKind> = {
  THE003: 'VEHICLE',
  THE001: 'ELEVATOR',
  THE002: 'ENTRY',
  DVPCTA: 'VEHICLE',
  DVPCTB: 'ELEVATOR',
  DVPCTC: 'ENTRY',
  DVPCT: 'VEHICLE',
};

export function isCardIssuanceFeeCode(feeCode?: string | null): boolean {
  if (!feeCode) return false;
  const code = feeCode.trim().toUpperCase();
  return code in FEE_CODE_TO_KIND;
}

export function getAccessCardKindForFeeCode(feeCode?: string | null): AccessCardKind | null {
  if (!feeCode) return null;
  return FEE_CODE_TO_KIND[feeCode.trim().toUpperCase()] ?? null;
}

export function parseLicensePlateFromCardInvoiceNotes(notes?: string | null): string | null {
  const trimmed = notes?.trim();
  if (!trimmed) return null;
  const match = trimmed.match(/Biển số:\s*([^,]+)/i);
  const plate = match?.[1]?.trim();
  return plate && plate !== '-' ? plate : null;
}

export function formatCardIssuanceFeeNotes(invoice: {
  notes?: string | null;
  cardIssuanceDisplayNotes?: string | null;
  cardIssuanceLicensePlate?: string | null;
  accessCard?: { cardNumber: string; cardCode?: string | null } | null;
  feeCategory?: { feeCode?: string | null } | null;
  fee?: { feeCategory?: { feeCode?: string | null } | null };
}): string | null {
  if (invoice.cardIssuanceDisplayNotes?.trim()) {
    return invoice.cardIssuanceDisplayNotes.trim();
  }
  const feeCode = invoice.feeCategory?.feeCode ?? invoice.fee?.feeCategory?.feeCode;
  if (!isCardIssuanceFeeCode(feeCode)) {
    return invoice.notes?.trim() || null;
  }
  const plateFallback = invoice.cardIssuanceLicensePlate?.trim();
  const fromNotes = invoice.notes?.trim();
  if (fromNotes) {
    if (plateFallback && !parseLicensePlateFromCardInvoiceNotes(fromNotes)) {
      return `${fromNotes}, Biển số: ${plateFallback}`;
    }
    return fromNotes;
  }
  if (invoice.accessCard) {
    const parts = [`Số thẻ: ${invoice.accessCard.cardNumber}`];
    if (invoice.accessCard.cardCode?.trim()) {
      parts.push(`Mã thẻ (UID): ${invoice.accessCard.cardCode.trim()}`);
    }
    if (plateFallback) {
      parts.push(`Biển số: ${plateFallback}`);
    }
    return parts.join(', ');
  }
  return null;
}
